import { APP_PARAMS_INITIALIZED, APP_PARAMS_ERROR } from '../actions/index'

const initialState = {
  site: null,
  locale: 'en-GB',
  errorMessage: null,
}

export default function initApp(state = initialState, action) {
  switch (action.type) {
    case APP_PARAMS_INITIALIZED: {
      return {
        ...state,
        site: action.payload.site,
        locale: action.payload.locale || state.locale,
      }
    }
    case APP_PARAMS_ERROR: {
      return {
        ...state,
        errorMessage: action.payload.message,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/init-app.js